import type { Proximity } from "@/api/employeeMovements";
import { METHOD_ICON, PROXIMITY, SOURCE } from "@/stores/constants";
import type { IconName } from "@fortawesome/fontawesome-svg-core";
import { useI18n } from "vue-i18n";

export const useTimelines = () => {
  const { t } = useI18n();

  const methodIcon = (source?: string, proximity?: Proximity): IconName => {
    switch (source) {
      case SOURCE.KIOSK:
        return METHOD_ICON.TABLET;
      case SOURCE.DASHBOARD:
        return METHOD_ICON.DISPLAY;
      case SOURCE.CONTACTLESS:
        return METHOD_ICON.QRCODE;
      case SOURCE.MOBILE:
        if (
          [PROXIMITY.QR_STATIC, PROXIMITY.QR_DYNAMIC].includes(
            proximity as PROXIMITY
          )
        ) {
          return METHOD_ICON.QRCODE;
        }
        return METHOD_ICON.MOBILE;
      case SOURCE.SYSTEM:
        return METHOD_ICON.DISPLAY;
      default:
        return METHOD_ICON.TABLET;
    }
  };

  const methodLabel = (source?: string) => {
    switch (source) {
      case SOURCE.KIOSK:
        return t("methods.kiosk");
      case SOURCE.DASHBOARD:
        return t("methods.dashboard");
      case SOURCE.CONTACTLESS:
        return t("methods.contactless");
      case SOURCE.MOBILE:
        return t("methods.mobile");
      case SOURCE.SYSTEM:
        return t("methods.system");
      default:
        return "";
    }
  };

  return {
    methodIcon,
    methodLabel,
  };
};
